import React, { useEffect } from "react";
import styled from "styled-components";
import { CartItems } from "../components";
import PayButton from "../subComponent/PayButton";
import { useStateContext } from "../contexts/ContextProvider";
import { TailSpin } from "react-loader-spinner";
const Cart = () => {
  const {
    setIsScrolled,
    cartItem,
    setCartItem,
    total,
    sumOfQuantity,
    getCartFromLocalStorage,
  } = useStateContext();

  window.onscroll = () => {
    setIsScrolled(window.pageYOffset === 0 ? false : true);
    return () => (window.onscroll = null);
  };

  useEffect(() => {
    if (localStorage.getItem("cartitems") === null) {
      console.log("no cartitems");
      let del = [];
      localStorage.setItem("cartitems", JSON.stringify(del));
      setCartItem(del);
    } else {
      getCartFromLocalStorage();
    }
  }, []);

  return (
    <Component>
      <ComponentWrapper>
        {/* Shopping Cart */}
        <Items>
          <ItemWrapper>
            <h4>Shopping Basket</h4>
            <Product>
              {cartItem
                ?.slice()
                .reverse()
                .map((cart, i) => (
                  <CartItems cart={cart} cartItems={cartItem} key={i} />
                ))}
            </Product>
          </ItemWrapper>
        </Items>

        {/* Checkout Container */}
        <CheckOutContainer>
          {/* Checkout */}
          <Checkout>
            <CheckoutWrapper>
              <h4>Summary</h4>
              {/* Order total */}

              {/* Total */}
              <Total style={{ borderTop: "1px solid #f6c2e5" }}>
                <div className="row">
                  {" "}
                  <p>Quantity</p> <p>{parseFloat(sumOfQuantity)}</p>
                </div>
                <div className="row">
                  <p>Total</p> <p>${parseFloat(total).toFixed(2)}</p>
                </div>
              </Total>
            </CheckoutWrapper>
          </Checkout>
          {/* Checkout button */}
          <CheckOutButton>
            <PayButton cartitem={cartItem} />
          </CheckOutButton>
        </CheckOutContainer>
      </ComponentWrapper>
    </Component>
  );
};

export default Cart;

const Component = styled.div`
  margin-top: 14vh;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100vw;
  overflow: hidden;
`;

const ComponentWrapper = styled.div`
  width: 100vw;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  @media (max-width: 440px) {
    flex-direction: column-reverse;
  }
`;

const Items = styled.div`
  width: 70vw;
  margin: 20px;
  border: 1px solid pink;

  border-radius: 10px;
  min-height: 40vh;
  box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
  -webkit-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
  -moz-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
  background: #ffffff;

  @media (max-width: 440px) {
    width: 90vw;
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px 17px;
  margin-top: 0px;
  h4 {
    font-size: 37px;
    margin-top: 19px;
    padding-bottom: 10px;
    border-bottom: 1px solid #979797;
    @media (max-width: 440px) {
      font-size: 17px;
    }
  }
  @media (max-width: 440px) {
    margin: 10px 4px;
  }
`;

const CheckOutContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  right: 0;
  top: 0;

  @media (max-width: 440px) {
    top: -2vh;
  }
`;

const Checkout = styled.div`
  width: 30vw;
  margin: 20px;
  border: 1px solid pink;
  border-radius: 10px;

  height: auto;
  box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
  -webkit-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
  -moz-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
  background: #fdf6fc;
  @media (max-width: 440px) {
    background: #fff;
    width: 90vw;
  }
`;

const Product = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CheckoutWrapper = styled.div`
  margin: 17px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  h4 {
    margin-top: 0px;
    font-size: 19px;
  }
`;

const Total = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .row {
    display: flex;
    width: 100%;
    justify-content: space-between;

  }
`;

const CheckOutButton = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    padding: 10px 30px;
    margin-right: 20px;
    border-radius: 20px;
    border: 1px solid #575156;
    background: #96147c;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 240px;
    height: 50px;
    justify-content: space-between;
    justify-content: center;
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.29);
    -webkit-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.29);
    -moz-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.29);
    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
    .wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
`;
